import { usePage } from "@inertiajs/react"

import type { Auth } from "@/types"

/**
 * The current user's permission keys — the same strings the Pundit policies
 * check server-side (see Role::PERMISSIONS). Use it to decide what to render;
 * the server still decides what's allowed.
 */
export function usePermissions() {
  const auth = usePage().props.auth as Auth | undefined
  const permissions = auth?.user?.permissions ?? []

  return {
    permissions,
    can: (key: string) => permissions.includes(key),
    canAny: (...keys: string[]) =>
      keys.some((key) => permissions.includes(key)),
  }
}
